import { VisualSize } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';
import { isEqualWith } from 'lodash';
import * as React from 'react';
import { IGk } from '../../store/pik_data/gks';
import { Map } from '../Map';
import { PikButton } from '../../ui/pik_button/pik_button';
import { getRegionCenter, Region } from '../../utils/regions';
import { PikLink } from '../pik_link/pik_link';
import { GK } from './gk/gk';
import { Tabs } from './tabs/tabs';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../types/redux';
import { resetFilterInRegion } from '../../actions/filter';

const styles = require('./gks.css');

type TabId = 'map' | 'tiles';

interface IState {
  showAllGKs: boolean;
  tab: TabId;
}

interface IGksProps {
  gks: IGk[];
  region: Region;
  resetFilterInRegion(region: Region): void;
}

class GKsComponent extends React.PureComponent<IGksProps, IState> {
  public state: IState = {
    showAllGKs: false,
    tab: 'tiles',
  };

  public UNSAFE_componentWillReceiveProps(nextProps: IGksProps) {
    if (!isEqualWith(nextProps.gks, this.props.gks, (x, y) => x.id === y.id)) {
      this.setState({ showAllGKs: false });
    }
  }

  public render() {
    const { state } = this;
    const empty = this.props.gks.length === 0;

    const activeTab = empty ? 'empty' : state.tab;

    return (
      <div className={styles['gks']}>
        <Tabs onTabToggle={this.toggleTab} tab={state.tab} empty={empty} containerStyle={styles.tabs} />
        {this.renderTabsPage(activeTab)}
      </div>
    );
  }

  private toggleTab = (tab: TabId) => this.setState({ tab });

  private renderTabsPage = (tab: string) => {
    const moreGKsCount = this.props.gks.length - 6;

    const tabs: { [key: string]: React.ReactNode } = {
      empty: (
        <div className={styles['empty']}>
          <p className={styles['empty-text']}>По вашему запросу ничего не найдено</p>

          <PikLink
            pikStyles={styles['empty-link']}
            to={{ query: { location: this.props.region.toString() } }}
            onClick={() => this.props.resetFilterInRegion(this.props.region.toString() as Region)}
          >
            Показать все ЖК в этом регионе
          </PikLink>
        </div>
      ),
      map: (
        <div className={styles['map']}>
          <Map mapId="gks-map" pins={this.props.gks} initialCenter={getRegionCenter(this.props.region)} />
        </div>
      ),
      tiles: (
        <div className={styles['tiles']}>
          <section className={styles['list']}>{this.renderGKs()}</section>

          <div className={styles['button-wrapper']}>
            {!this.state.showAllGKs && moreGKsCount > 0 && (
              <PikButton onClick={this.showAllGKs} pikTheme="blue" size={VisualSize.MEDIUM}>
                Показать еще {moreGKsCount} {plural(moreGKsCount, ['объект', 'объекта', 'объектов'])}
              </PikButton>
            )}
          </div>
        </div>
      ),
    };

    return tabs[tab];
  };

  private showAllGKs = () => this.setState({ showAllGKs: true });

  private renderGKs = () => {
    const gks = this.state.showAllGKs ? this.props.gks : this.props.gks.slice(0, 6);

    return gks.map(gk => (
      <GK
        key={gk.id}
        address={gk.address}
        finishInfo={gk.finishInfo}
        imgUrl={gk.imgUrl}
        promoLabel={gk.promoLabel}
        publicUrl={gk.publicUrl}
        rooms={gk.rooms}
        title={gk.title}
        undegroundInfo={gk.undegroundInfo}
      />
    ));
  };
}

export const GKs = connect(
  (state: IApplicationState) => ({
    gks: state.gks || [],
    region: state.filter.query.region,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      resetFilterInRegion: (region: Region) => {
        dispatch(resetFilterInRegion(region));
      },
    };
  },
)(GKsComponent);
